import React from 'react';

export const sceneSevenMeta = {
  id: 'meditation-purpose',
  title: '場景七｜禪修的目的',
  excerpt: '禪修不是逃避世界，而是看清自己，拿回心的主導權。',
};
const SceneSevenMeditationPurpose: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneSevenMeta.title}</h2>

    <p>禪修，表面上像是在「打坐、安靜、閉眼」。</p>
    <p>但真正深的目的，並不是逃避世界，而是——看清自己。</p>

    <p>很多人以為禪修是變平靜、消除煩惱、開悟，甚至得到某種神秘力量。</p>
    <p>但其實更核心的是：看見「心」是怎麼運作的。</p>

    <h3>一、一般人的心，其實像暴風中的森林</h3>
    <p>人平常以為自己很清醒，但其實大部分時間，都被情緒推著走、被欲望拉著跑、被恐懼控制、被比較折磨。</p>
    <p>有時候，被過去後悔；有時候，被未來焦慮。</p>
    <p>腦中永遠有聲音：</p>
    <ul>
      <li>我是不是不夠好？</li>
      <li>別人怎麼看我？</li>
      <li>會不會失敗？</li>
      <li>如果賠錢怎麼辦？</li>
      <li>他為什麼這樣對我？</li>
    </ul>
    <p>禪修不是強迫停止這些念頭，而是你開始「看見」它們。</p>

    <h3>二、禪修最重要的能力：覺察</h3>
    <p>禪宗很重視一件事：知道自己正在想什麼。這叫「覺」。</p>
    <p>例如你憤怒時，以前是直接爆炸；現在變成：「喔，我正在生氣。」</p>
    <p>這中間，就出現了一點空間。</p>
    <blockquote>人生真正的自由，往往就在這一點點空間裡。</blockquote>

    <h3>三、禪修不是變成沒有情緒</h3>
    <p>很多人誤會修行，以為高僧都不痛苦、不悲傷、不生氣。</p>
    <p>不是。</p>
    <p>而是情緒來了，他不被情緒拖走。</p>
    <p>像森林裡的大樹：風吹，它知道風吹；下雨，它知道下雨；冬天，它知道冬天。</p>
    <p>但它不會因為一場風雨，就忘記自己的根。</p>

    <h3>四、禪修真正修的是「不被外界綁架」</h3>
    <p>現代人最大問題不是忙，而是心一直被外界拖著跑。</p>
    <p>手機通知、股價漲跌、社群比較、別人的一句話，都能讓心震動。</p>
    <p>於是人越來越失去專注、安定、深度與長期思考能力。</p>
    <p>禪修其實是在重新拿回心的主導權。</p>
    <p>很多真正厲害的人，最後都會走向安靜。因為他們發現：外在再大，如果內心混亂，人生仍然會崩塌。</p>

    <h3>五、禪修最後會慢慢看見「我執」</h3>
    <p>佛法很核心的一件事叫「執著」。</p>
    <p>人痛苦，很多時候不是事情本身，而是心裡那個「一定要怎樣」。</p>
    <ul>
      <li>一定要成功</li>
      <li>一定要被愛</li>
      <li>一定要贏</li>
      <li>一定不能失敗</li>
      <li>一定要照我的意思</li>
    </ul>
    <p>但世界本來就無常。樹葉會掉，季節會變，人會老，市場會崩，關係會散。</p>
    <p>禪修不是否定人生，而是慢慢理解：世界本來就是流動的。</p>
    <p>當你不再死抓著一切，心才開始鬆開。</p>

    <h3>六、真正深的禪修，最後會回到生活</h3>
    <p>不是躲進山裡才叫修行。</p>
    <p>真正成熟的人，吃飯時知道自己在吃飯，走路時知道自己在走路，說話時知道自己的情緒。</p>
    <p>投資時，知道自己的貪婪與恐懼；衝突時，知道自己的執念。</p>
    <p>這其實已經是禪。</p>
    <blockquote>六祖惠能說：「佛法在世間，不離世間覺。」</blockquote>
    <p>真正的修行，不是離開世界，而是在世界裡，保持清醒。</p>

    <h3>七、如果用一棵老樹形容禪修</h3>
    <p>禪修像一棵樹，慢慢向下扎根。</p>
    <p>一開始，人只想讓葉子漂亮。後來才發現：真正重要的是根。</p>
    <p>當根越深，外界的風，吹不倒你；別人的評價，動不了你；市場的波動，嚇不了你；人生的無常，也不再那麼恐怖。</p>
    <p>最後，會慢慢進入弘一大師臨終前所說的狀態：</p>
    <blockquote>華枝春滿，天心月圓。</blockquote>
    <p>不是人生沒有風雨，而是即使經歷風雨，心裡仍有一輪明月。</p>
  </article>
);

export default SceneSevenMeditationPurpose;
